/*
 * /faxes/$patientId (page)
 */
import { Card, CardContent, CardHeader, CardTitle, Container, Page, Placeholder } from "@emr/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import { trpc } from "../../trpc"
import { PatientHeader } from "../../features/patient/patient-header"
import { PatientFaxList } from "../../features/fax/patient-fax-list"
import type { Patient } from "@emr/db/client"

export const Route = createFileRoute("/faxes/$patientId")({
	component: FaxesPage,
})

const MOCK_PATIENT: Partial<Patient> = {
	firstName: "...",
	lastName: "",
	dateOfBirth: null,
	bloodType: null,
	allergies: null,
	emergencyContactName: null,
	emergencyContactPhone: null,
}

function FaxesPage() {
	const { patientId } = Route.useParams()

	const { data: patient, isLoading } = trpc.patient.getByFilter.useQuery({
		where: { id: patientId },
	})

	const displayPatient = patient ?? (MOCK_PATIENT as Patient)

	return (
		<Page centerVertical={false}>
			<PatientHeader patient={displayPatient} patientId={patientId} isDirty={false} />
			<Container width="xl" padding="lg" gap="lg">
				{isLoading ? (
					<Placeholder title="Loading..." />
				) : (
					<Card>
						<CardHeader>
							<CardTitle>Fax History</CardTitle>
						</CardHeader>
						<CardContent>
							<PatientFaxList patientId={patientId} />
						</CardContent>
					</Card>
				)}
			</Container>
		</Page>
	)
}
